"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ns = exports.companyName = void 0;
exports.companyName = "Ural Kalii";
exports.ns = "asu";
//# sourceMappingURL=company.js.map